// @flow
import { ConfOpinometroActionTypes } from './constants';

type ConfOpinometroAction = { type: string, payload: {} | string };

// common success
export const confOpinometroApiResponseSuccess = (actionType: string, data: any): ConfOpinometroAction => ({
    type: ConfOpinometroActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const confOpinometroApiResponseError = (actionType: string, error: string): ConfOpinometroAction => ({
    type: ConfOpinometroActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getConfOpinometro = (confOpinometroId, destination): ConfOpinometroAction => ({
    type: ConfOpinometroActionTypes.GET_CONF_OPINOMETRO,
    payload: { confOpinometroId, destination },
});

export const updateConfOpinometro = (confOpinometro: any): ConfOpinometroAction => ({
    type: ConfOpinometroActionTypes.UPDATE_CONF_OPINOMETRO,
    payload: confOpinometro
})

export const resetConfOpinometro = (): ConfOpinometroAction => ({
    type: ConfOpinometroActionTypes.RESET,
    payload: {},
});

